import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { selectCustomAttributes } from 'store/CustomAttributes/selectors';
import CustomField from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/CustomFieldsTab/components/CustomField/index';
import { Wrapper, NoFieldsText } from './styled';
import ExpandableWrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ExpandableWrapper';
import getCustomFieldValueFromVuln from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/CustomFieldsTab/functions';
import { selectField, selectVulnTemplateDetail } from 'store/KnowledgeBase/selectors';
import { setVulnTemplateCustomAttribute } from 'Screens/Contextualization/KnowledgeBase/actions/Actions';
import { setCustomAttribute } from 'Screens/Contextualization/KnowledgeBaseEditCreate/actions/Actions';
import useExpandable from 'Hooks/useExpandable';
import isEmpty from 'lodash/isEmpty';

const ID = 'customAttributes';

const CustomFieldWrapper = ({ field }) => {
  const vulnTemplate = useSelector(selectVulnTemplateDetail);
  const editValue = useSelector((state) => selectField(state, field));
  const initialValue = vulnTemplate ? getCustomFieldValueFromVuln(vulnTemplate, field, 'template') : editValue;
  const isExpanded = useExpandable(ID, field.field_name, initialValue);
  const dispatch = useDispatch();
  const onSaveCustomAttribute = (vulnTemplate, fieldName, fieldValue) => {
    if (vulnTemplate) {
      dispatch(setVulnTemplateCustomAttribute(vulnTemplate, fieldName, fieldValue));
    } else {
      dispatch(setCustomAttribute(fieldName, fieldValue));
    }
  };
  return (
    <ExpandableWrapper defaultValue={ isExpanded } key={ `expandible_custom_${field.id}` } id={ field.field_name } title={ field.field_display_name } tab="customAttributes">
      <CustomField field={ field } key={ `Custom_Field_${field.id}` } initialValue={ initialValue } dataSelected={ vulnTemplate } onSave={ onSaveCustomAttribute } entity="vuln" />
    </ExpandableWrapper>
  );
};

const CustomFieldsTab = () => {
  const intl = useIntl();
  const customAttributes = useSelector(selectCustomAttributes);

  return (
    <Wrapper>
      { customAttributes.map((ca) => <CustomFieldWrapper key={ `custom_field_wrapper_${ca.id}` } field={ ca } />) }
      { isEmpty(customAttributes) && <NoFieldsText children={ intl.formatMessage({ id: 'customAttributes.empty' }) } /> }
    </Wrapper>
  );
};

export default CustomFieldsTab;
